import React from 'react';
import churroImg from '../assets/churro4.jpeg';
import empImg from '../assets/empanadas.jpeg';
import './Menu.css';

const menuCategories = [
  {
    category: 'Our Signature Churros',
    subtitle: 'Crafted from our proprietary vegan recipe, each churro is hand-pressed and fried to a perfect golden crisp.',
    image: churroImg,
    items: [
      {
        name: 'Traditional Churros (2-Pack)',
        description: 'Our classic handmade churros, tossed in our signature cinnamon-sugar coating. A perfect snack to satisfy your cravings.',
        tag: 'Best Seller',
        addon: 'Elevate your experience: Add Dulce de Leche, Chocolate, or ask about our Seasonal Filling Sauces.'
      },
      {
        name: 'Traditional Churros (3-Pack)',
        description: 'Three of our signature hand-pressed churros for those who simply can\'t get enough of that golden crunch.',
        tag: '',
        addon: 'Elevate your experience: Add Dulce de Leche, Chocolate, or ask about our Seasonal Filling Sauces.'
      },
      {
        name: 'Mini-Churros',
        description: 'Bite-sized versions of our traditional favorites. Wonderful for kids or for sharing a moment of sweetness with friends and family.',
        tag: 'Great for Sharing',
        addon: ''
      },
      {
        name: 'The Texas Churro-Loop',
        description: 'Our answer to the Texas heat! A large, golden churro hand-shaped into a beautiful loop, served with two scoops of premium ice cream of your choice. The ultimate summer treat.',
        tag: 'Signature',
        addon: ''
      }
    ]
  },
  {
    category: 'Our Savory Empanadas',
    subtitle: 'Tucked inside our handmade dough is a world of warmth and tradition. Each empanada is served with a side of our famous, traditional Tomatillo Salsa.',
    image: empImg,
    items: [
      {
        name: 'Heritage Beef',
        description: 'Seasoned ground beef slow-cooked with a blend of carrots, celery, onions, and garlic. A savory classic that tastes like home.',
        tag: 'Best Seller',
        addon: ''
      },
      {
        name: 'Garden Chicken',
        description: 'Tender chicken sautéed with fresh veggies and our secret blend of spices.',
        tag: '',
        addon: ''
      }
    ]
  }
];

const Menu = () => {
  return (
    <section id="menu" className="menu">
      <div className="menu__container">
        <div className="menu__header">
          <span className="menu__label">Our Menu</span>
          <h2 className="menu__heading">
            Crafted With <span>Passion</span>
          </h2>
          <p className="menu__subheading">
            At Churros ATX, we believe the best flavor comes from simple, high-quality 
            ingredients and the steady hands of a maker. Every item on our menu is prepared 
            in small batches, onsite, to ensure that the treat you hold in your hand is as 
            fresh as it can possibly be.
          </p>
        </div>
        
        {menuCategories.map((category, idx) => (
          <div key={idx} className="menu__category">
            <div className="menu__category-banner">
              <img src={category.image} alt={category.category} />
              <div className="menu__category-banner-overlay">
                <div>
                  <h3 className="menu__category-title">
                    {category.category}
                  </h3>
                  <p className="menu__category-subtitle">{category.subtitle}</p>
                </div>
              </div>
            </div>
            <div className="menu__grid">
              {category.items.map((item, itemIdx) => (
                <div key={itemIdx} className="menu__card">
                  {item.tag && <span className="menu__tag">{item.tag}</span>}
                  <div className="menu__card-content">
                    <div className="menu__card-header">
                      <h4 className="menu__item-name">{item.name}</h4>
                    </div>
                    <p className="menu__item-desc">{item.description}</p>
                    {item.addon && (
                      <p className="menu__item-addon">✦ {item.addon}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}

        <div className="menu__ingredients-note">
          <div className="menu__ingredients-icon">🌿</div>
          <h3>A Little Note on Our Ingredients</h3>
          <p>
            We take pride in our community. That is why we source local, high-quality ingredients 
            whenever possible. Whether you are choosing our vegan churros or our hearty empanadas, 
            you are tasting the best of Texas and the best of our traditions.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Menu;
